<template>
  <div class="SubPage__container">
    <ShopPageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <Button colour="blue" text="Zurück zur Übersicht" isLink href="#" />
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-three-quarters">
          <HeaderBox
            type="Typen 111.10, 111.12"
            title="Rohrfedermanometer, CrNi-Stahl"
            text="Für die Prozessindustrie, Standardausführung, NG 63, 100 und 160"
            :links="['Datenblatt']"
            :shopExtras="{
              linkText: 'Weitere Informationen (WIKA-Webseite)',
              url: '#',
              deliveryNotice:
                'Lieferhinweis: Lagergeräte sofort versandfertig; Fertigungsgeräte siehe Artikeldetails.'
            }"
            :warning="{
              title: 'Warning',
              text:
                'This product can expose you to chemicals including Nickel and Chromium, which is known to the State of California to cause cancer and reproductive harm. For more information go to www.P65Warnings.ca.gov',
              url: '#'
            }"
          />
        </div>
        <div class="column">
          <div class="SubPage__shopImage">
            <img
              src="https://shop.wika.de/upload/WIKA_Thumbnails/Product-Detail-Large/PIC_PR_232_50_233_50_de_de_48101.jpg.png"
              alt="Rohrfedermanometer, CrNi-Stahl"
            />
            <span class="SubPage__shopImageCaption"
              >Beispielhafte Darstellung</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <ProductDetailTabs :config="tabsConfig" :shopConfig="shopConfig" />
      <ProductSlider :config="slider1" />
      <ProductSlider :config="slider2" />
    </div>
    <ShopFooter />
  </div>
</template>

<script>
import Button from "../Button/Button.vue";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.vue";
import ShopFooter from "../ShopFooter/ShopFooter.vue";
import ShopPageHeader from "../ShopPageHeader/ShopPageHeader.vue";
import HeaderBox from "../HeaderBox/HeaderBox.vue";
import ProductDetailTabs from "../ProductDetailTabs/ProductDetailTabs.vue";
import ProductSlider from "../ProductSlider/ProductSlider.vue";

export default {
  name: "ShopProductDetailPage",
  components: {
    Button,
    Breadcrumbs,
    ShopFooter,
    ShopPageHeader,
    HeaderBox,
    ProductDetailTabs,
    ProductSlider
  },
  props: {
    crumbs: undefined,
    tabsConfig: undefined,
    shopConfig: undefined,
    slider1: undefined,
    slider2: undefined
  },
  created() {
    window.instance = "shop";
  }
};
</script>
